import { DocumentExplorer } from '@features/parent-documents/components/DocumentExplorer'
import { parentDocumentFolderQueryOptions } from '@features/parent-documents/queries'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Box } from '@mantine/core'
import { DocumentExplorerBreadcrumbs } from '@features/parent-documents/components/DocumentExplorerBreadcrumbs'

const ROOT_DOCUMENT_FOLDER_ID = '01UOSBYRV6Y2GOVW7725BZO354PWSELRRZ'

export const Route = createFileRoute('/_layout/documents/{-$folderId}')({
    component: RouteComponent,
    beforeLoad: requireRouteAudience(['parent']),
    loader: async ({ params, context }) => {
        return context.queryClient.ensureQueryData(parentDocumentFolderQueryOptions(params.folderId ?? ROOT_DOCUMENT_FOLDER_ID))
    },
    staticData: {
        crumb: {
            render: (match) => <DocumentExplorerBreadcrumbs folderId={match.params.folderId ?? ROOT_DOCUMENT_FOLDER_ID} />,
        },
    },
})

function RouteComponent() {
    const { folderId } = Route.useParams()
    const navigate = useNavigate()

    return (
        <Box h="100%" w="100%" p={5}>
            <DocumentExplorer folderId={folderId ?? ROOT_DOCUMENT_FOLDER_ID} onSelectFolder={(id) => navigate({ to: `/documents/${id}` })} overrideHeader={true} />
        </Box>
    )
}
